import { ExtendedView } from 'views/store/common/utility/view/view';

import { ProjectChecklistModel } from 'models/store/client/projects/roomchecklists/project_checklist';

import 'store/global/common/projects/roomchecklists/_checklist_image.dust';
import _ProjectChecklistDust from 'store/global/common/projects/roomchecklists/_checklist_tile.dust';

export class ProjectChecklistView extends ExtendedView {
	static events = {
		select: 'view:projects:checklists:checklist:select',
		afterRender: 'view:projects:checklists:checklist:afterAfter'
	};

	get selectedClass() {
		return this._selectedClass;
	}

	get selected() {
		return this.model.get('selected');
	}

	get isMobile() {
		return window.BCOM.device.isMobile;
	}

	events() {
		return {
			click: 'onClick'
		};
	}

	preinitialize(options) {
		super.preinitialize(options);
		this.el = `.js-checklist-list > .js-checklist[data-id="${options.model.get('id')}"]`;
	}

	initialize(options) {
		super.initialize(options);
		this.projectId = options.projectId;
		this.createNewBlankOverride = options.createNewBlankOverride;
		this.showProProjectView = options._parent.showProProjectView;
		this.attachEvents();
	}

	attachEvents() {
		this.listenTo(this.model, 'change:selected', this.update);
		return this;
	}

	getDefaults() {
		return Object.assign(super.getDefaults(), {
			_selectedClass: 'theme-primary bg-theme-primary-light',
			model: new ProjectChecklistModel()
		});
	}

	cache() {
		this.$tile = this.$el.find('.js-tile');
		return this;
	}

	render() {
		super.element(this.afterRender.bind(this), _ProjectChecklistDust, {
			...this.model.toJSON(),
			withTile: true,
			tileClass: this.showProProjectView ? 'ph3' : 'ph1',
			tileSize: this.isMobile || this.showProProjectView ? 75 : 120,
			class: 'mt2 w-33 w-25-ns',
			labelClass: 'ttu'
		});
	}

	afterRender() {
		return this.cache()
			.update()
			.delegateEvents();
	}

	update() {
		const { selectedClass } = this;
		this.selected ? this.$tile.addClass(selectedClass) : this.$tile.removeClass(selectedClass);
		return this.trigger(ProjectChecklistView.events.select, this.model);
	}

	select() {
		this.model.setSelected(true);
		return this;
	}

	deselect() {
		this.model.setSelected(false);
		return this;
	}

	onClick(e) {
		e.preventDefault();
		return this.selected ? this.deselect() : this.select();
	}
}
